import clsx from 'clsx'
import ReactPagination from 'react-paginate'

import usePagination from '@/hooks/usePagination'

import changePage from './functions/changePage'
import PaginationButton from './PaginationButton'
import css from './scss/index.module.scss'
import { PaginationProps } from './ts'

function Pagination(props: PaginationProps) {
  const {
    totalItems = 0,
    limit,
    scrollViewOffsetTop,
    className,
    replace = false,
  } = props
  const { page, pageCount } = usePagination(totalItems, limit)

  const initialPage = page - 1

  if (pageCount <= 1) return null

  return (
    <ReactPagination
      containerClassName={clsx(css.pagination, className)}
      pageLinkClassName={css.page}
      activeLinkClassName={css['page--active']}
      breakLinkClassName={css.break}
      pageCount={pageCount}
      initialPage={initialPage}
      forcePage={initialPage}
      onPageChange={(e) => changePage(e, scrollViewOffsetTop, replace)}
      disableInitialCallback
      marginPagesDisplayed={1}
      pageRangeDisplayed={5}
      previousLabel={page > 1 && <PaginationButton direction="left" />}
      nextLabel={page < pageCount && <PaginationButton direction="right" />}
    />
  )
}

export default Pagination
